import { LoginModule } from '@ebw-monorepo/login';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I18NTranslateModule } from '@ebw-monorepo/i18n-translate';
import { MaterialModule } from '@ebw-monorepo/material';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserProfileMenuComponent } from './user-profile-menu/user-profile-menu.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { ListModule } from '@ebw-monorepo/list';
import { QuillModule } from 'ngx-quill';
import { UserProfileRoutingModule } from './user-profile-routing.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ListModule,
    I18NTranslateModule,
    FormsModule,
    UserProfileRoutingModule,
    QuillModule.forRoot({
      customOptions: [
        {
          import: 'formats/font',
          whitelist: ['mirza', 'roboto', 'aref', 'serif', 'sansserif', 'monospace']
        }
      ]
    }),
    ReactiveFormsModule,
    LoginModule
  ],
  declarations: [UserProfileMenuComponent, UserProfileComponent],
  exports: [UserProfileMenuComponent, UserProfileComponent]
})
export class UserProfileModule {}
